import HTTP from '@/config/axios-config-erp'

const SrvAlbaranes = {
  estadoPedidosAlbClte(payload) {
    return HTTP.post(`/wscomun/portalinformes/estadoPedidosAlbClte`, payload).then(respuesta => {
      if (respuesta.status === 200) {
        return respuesta
      } else {
        console.error(respuesta)
        return respuesta
      }
    }).catch(error => {
      return error
    })
  },
  getEstadosPedidosWeb(payload) {
    return HTTP.post(`/wscomun/portalinformes/getEstadosPedidosWeb`, payload).then(respuesta => {
      if (respuesta.status === 200) {
        return respuesta
      } else {
        console.error(respuesta)
        return respuesta
      }
    }).catch(error => {
      return error
    })
  }
}

export default SrvAlbaranes



// WEBPACK FOOTER //
// ./src/services/srv-albaranes.js